export const space = {
  px: '1px',
  0.25: '0.125rem',
  0.5: '0.25rem',
  0.75: '0.375rem',
  1: '0.5rem',
  1.25: '0.625rem',
  1.5: '0.75rem',
  1.75: '0.875rem',
  2: '1rem',
  2.25: '1.125rem',
  2.5: '1.25rem',
  3: '1.5rem',
  3.5: '1.75rem',
  4: '2rem',
  4.5: '2.25rem',
  5: '2.5rem',
  6: '3rem',
  7: '3.5rem',
  8: '4rem',
  9: '4.5rem',
  10: '5rem',
  11: '5.5rem',
  12: '6rem',
  13: '6.5rem',
  14: '7rem',
  15: '7.5rem',
  16: '8rem',
  17: '8.5rem',
  18: '9rem',
  19: '9.5rem',
  20: '10rem',
  21: '10.5rem',
  22: '11rem',
  23: '11.5rem',
  24: '12rem',
  25: '12.5rem',
  26: '13rem',
  27: '13.5rem',
  28: '14rem',
  29: '14.5rem',
  30: '15rem',
  31: '15.5rem',
  32: '16rem',
  33: '16.5rem',
  34: '17rem',
  35: '17.5rem',
  36: '18rem',
  37: '18.5rem',
  38: '19rem',
  39: '19.5rem',
  40: '20rem',
  41: '20.5rem',
  42: '21rem',
  43: '21.5rem',
  44: '22rem',
  45: '22.5rem',
  46: '23rem',
  47: '23.5rem',
  48: '24rem',
  49: '24.5rem',
  50: '25rem',
  51: '25.5rem',
  52: '26rem',
  53: '26.5rem',
  54: '27rem',
  55: '27.5rem',
  56: '28rem',
  57: '28.5rem',
  58: '29rem',
  59: '29.5rem',
  60: '30rem',
  61: '30.5rem',
  62: '31rem',
  63: '31.5rem',
  64: '32rem',
  65: '32.5rem',
  66: '33rem',
  67: '33.5rem',
  68: '34rem',
  69: '34.5rem',
  70: '35rem',
} as const;
